import { render } from "./Rail.vue?vue&type=template&id=3542810f&scoped=true"
import script from "./Rail.vue?vue&type=script&lang=js"
export * from "./Rail.vue?vue&type=script&lang=js"

import "./Rail.vue?vue&type=style&index=0&id=3542810f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3542810f"]])

export default __exports__